/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ArrayOfAcademicProgramsItem model module.
 * @module model/ArrayOfAcademicProgramsItem
 * @version 2.0.0
 */
class ArrayOfAcademicProgramsItem {
    /**
     * Constructs a new <code>ArrayOfAcademicProgramsItem</code>.
     * @alias module:model/ArrayOfAcademicProgramsItem
     */
    constructor() { 
        
        ArrayOfAcademicProgramsItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ArrayOfAcademicProgramsItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ArrayOfAcademicProgramsItem} obj Optional instance to populate.
     * @return {module:model/ArrayOfAcademicProgramsItem} The populated <code>ArrayOfAcademicProgramsItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ArrayOfAcademicProgramsItem();

            if (data.hasOwnProperty('end_date_join')) {
                obj['end_date_join'] = ApiClient.convertToType(data['end_date_join'], 'String');
            }
            if (data.hasOwnProperty('ended_enroll_period')) {
                obj['ended_enroll_period'] = ApiClient.convertToType(data['ended_enroll_period'], 'Boolean');
            }
            if (data.hasOwnProperty('exam_certificate')) {
                obj['exam_certificate'] = ApiClient.convertToType(data['exam_certificate'], 'Boolean');
            }
            if (data.hasOwnProperty('joined_certificate')) {
                obj['joined_certificate'] = ApiClient.convertToType(data['joined_certificate'], 'Boolean');
            }
            if (data.hasOwnProperty('academic_program_title')) {
                obj['academic_program_title'] = ApiClient.convertToType(data['academic_program_title'], 'String');
            }
            if (data.hasOwnProperty('show_event_address')) {
                obj['show_event_address'] = ApiClient.convertToType(data['show_event_address'], 'Boolean');
            }
            if (data.hasOwnProperty('has_evau_inscription')) {
                obj['has_evau_inscription'] = ApiClient.convertToType(data['has_evau_inscription'], 'Boolean');
            }
            if (data.hasOwnProperty('has_evau_documentation')) {
                obj['has_evau_documentation'] = ApiClient.convertToType(data['has_evau_documentation'], 'Boolean');
            }
            if (data.hasOwnProperty('current_formative_actions')) {
                obj['current_formative_actions'] = ApiClient.convertToType(data['current_formative_actions'], Object);
            }
            if (data.hasOwnProperty('next_formative_actions')) {
                obj['next_formative_actions'] = ApiClient.convertToType(data['next_formative_actions'], Object);
            }
        }
        return obj;
    }


}

/**
 * @member {String} end_date_join
 */
ArrayOfAcademicProgramsItem.prototype['end_date_join'] = undefined;

/**
 * @member {Boolean} ended_enroll_period
 */
ArrayOfAcademicProgramsItem.prototype['ended_enroll_period'] = undefined;

/**
 * @member {Boolean} exam_certificate
 */
ArrayOfAcademicProgramsItem.prototype['exam_certificate'] = undefined;

/**
 * @member {Boolean} joined_certificate
 */
ArrayOfAcademicProgramsItem.prototype['joined_certificate'] = undefined;

/**
 * @member {String} academic_program_title
 */
ArrayOfAcademicProgramsItem.prototype['academic_program_title'] = undefined;

/**
 * @member {Boolean} show_event_address
 */
ArrayOfAcademicProgramsItem.prototype['show_event_address'] = undefined;

/**
 * @member {Boolean} has_evau_inscription
 */
ArrayOfAcademicProgramsItem.prototype['has_evau_inscription'] = undefined;

/**
 * @member {Boolean} has_evau_documentation
 */
ArrayOfAcademicProgramsItem.prototype['has_evau_documentation'] = undefined;

/**
 * @member {Object} current_formative_actions
 */
ArrayOfAcademicProgramsItem.prototype['current_formative_actions'] = undefined;

/**
 * @member {Object} next_formative_actions
 */
ArrayOfAcademicProgramsItem.prototype['next_formative_actions'] = undefined;






export default ArrayOfAcademicProgramsItem;

